<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_AddCharges')"
      width="1000px"
      :close-on-click-modal="false"
      class="app-main-inner"
    >
      <div class="app-main-inner-row row-grid" style="height:350px;padding:0">
        <cargo-ag-grid
          config-module="1001001"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width:100%"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <span slot="footer" style="padding:10px">
        <div style="float:left">
          <el-button type="primary" @click="toAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
          <el-button type="danger" @click="toRemove">{{ $t('CargoMsg.Cargo_Remove') }}</el-button>
          <el-button type="primary" @click="toChangeSchema">{{ $t('SeaExport.ChangeSchema') }}</el-button>
          <!-- 应收应付合计显示区域 -->
          <span style="margin-left:20px;font-weight:bold;color:#409EFF;">
            <!-- 应收合计：chargeType为0（应收应付）或1（应收）时显示 -->
            <template v-if="chargeType === 0 || chargeType === 1">
              <span>{{ $t('CargoMsg.Cargo_Receivable') }}：</span><span v-html="arTotalDisplay" />
            </template>
            <!-- 应付合计：chargeType为0（应收应付）或2（应付）时显示 -->
            <template v-if="chargeType === 0 || chargeType === 2">
              <span style="margin-left:20px;">{{ $t('CargoMsg.Cargo_Dues') }}：</span><span v-html="apTotalDisplay" />
            </template>
          </span>
        </div>
        <div style="float:right">
          <el-button type="primary" @click="toSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button @click="toCancel">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { Charge } from '@/class/model/act/Charge'
import {
  BY_CNTR_CHARGE_MEASURE,
  CHARGE_MEASURES
} from '@/class/cargo/model/parameters/ChargeMeasure'
import { EQ_SIZES } from '@/class/cargo/model/parameters/EQSize'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import ColumnUtils from '@/utils/ColumnUtils'
import { cacheName, cache } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'
import { batchSaveCharge } from '@/api/seaExport/seaExportJob'
import { seaEQList } from '@/api/seaExport/seaEQ'
import { getCustomerByRole, validateChargeLockStatus, validateChargeLockStatusByType } from '@/api/booking/job'
import { getFilterCacheList } from '@/utils/basicDataCache'
import { Assert } from '@/utils/validate'
import lang from '@/lang'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as jobApi from '@/api/seaExport/seaExportJob'
import { chargeItemCompatibleLanguage, multiply, stringToBool } from '@/utils/commonUtil'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { queryTitleByCpmIdx, queryTitlesByCmpIdx } from '@/api/partner/title'
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'AddChargeDetailDialog',
  props: {
    visible: { type: Boolean, required: true },
    selectedJobs: { type: Array, required: true, default: () => [] },
    lob: { type: String, required: true },
    location: { type: String, required: false },
    chargeType: { type: Number, default: SystemConstants.CHARGE_TYPE_RADIO_COST_PAY.code },
    selectedScheme: { type: Array, required: false, default: () => [] } // 选择的费用方案数据
  },
  data() {
    const chargeMeasures = [BY_CNTR_CHARGE_MEASURE, ...CHARGE_MEASURES]
    const eqTypes = getCacheListByKey(TYPE_NAMES.basic_data_EQType)
    return {
      innerVisible: false,
      BY_CNTR_CHARGE_MEASURE,
      chargeMeasures,
      eqTypes,
      gridOptions: {
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridSelectEditor,
          CargoAgGridCommonInputEditor
        },
        singleClickEdit: true,
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          const selectedNode = nodes[event.rowIndex] || null
          if (selectedNode) {
            this.customerStaticOptions = selectedNode.data.receivable ? this.customerCmpList : null
          }
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      office: {},
      user: {},
      department: {},
      chargeWeightValueType: 0,
      arSettlementUnitOptional: false,
      isSpecialExpenseEntryFunction: false,
      currencyChangeBySettlementAccount: 2,
      companyFactorySigns: [], // 委托单位和关联的工厂
      gridApi: null,
      customerCmpList: null,
      customerStaticOptions: null,
      // 结算单位类型
      partnerTypeList: [
        { desc: this.$t('CargoMsg.Cargo_Customer'), code: 'customerId' },
        { desc: this.$t('CargoMsg.Cargo_Carrier'), code: 'carrierId' },
        { desc: `${this.$t('queryJob.bookingAgent')}/${this.$t('SeaExport.BillExchangeAgent')}`, code: 'bookingAgent' },
        { desc: `${this.$t('SeaExport.DestinationAgent1')}/${this.$t('queryJob.destinationAgent')}`, code: 'destinationAgent' },
        { desc: this.$t('CargoMsg.Cargo_CustomsBroker'), code: 'customsBroker' }
      ],
      inputIncludingTaxUnitPrice: 0, // 单价是否含税
      isControlled: this.$checkPermission(['button_Charge_controlled']), // 是否有应付受控费用权限
      isCostControlled: this.$checkPermission(['button_Charge_costControlled']), // 是否有应收受控费用权限
      chargeItemSet: new Set(),
      customerTitlesMap: new Map() // 委托单位和关联的发票抬头
    }
  },
  computed: {
    // 应收合计显示
    arTotalDisplay() {
      return this.calculateTotalDisplay(true)
    },
    // 应付合计显示
    apTotalDisplay() {
      return this.calculateTotalDisplay(false)
    },
    columnDefs() {
      const result = [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_RevenueAndExpenditureType'),
          field: 'receivable',
          colId: 'receivable',
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          },
          editable: this.chargeType === 0,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: [{ code: true, value: this.$t('CargoMsg.Cargo_Receivable') }, { code: false, value: this.$t('CargoMsg.Cargo_Dues') }],
            tagName: 'value',
            tagValue: 'code'
          },
          width: 150,
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChargeName'),
          field: 'chargeItemId',
          colId: 'chargeItemId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...this.chargeItemSet],
              methodParams: this.getChargeItemFilter(),
              tagValue: 'itemId',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              callbackParams: { key: 'chargeItemId' },
              customLabel: item => this.$store.getters.language === 'zh' ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          },
          onCellValueChanged: params => this.onCellChange(params),
          width: 200
        }, {
          headerName: this.$t('SeaExport.PartnerType'),
          colId: 'partnerType',
          field: 'partnerType',
          cellRenderer: (params) => {
            return ColumnUtils.partnerTypeLabelFunction(params.value)
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: true,
              fileds: ['code'],
              callbackParams: { key: 'partnerType' },
              callbackMethodType: 'value',
              tagValue: 'code',
              tagName: 'desc',
              staticOptions: [...this.partnerTypeList],
              filterTagNames: ['desc']
            }
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'),
          colId: 'accountId',
          field: 'accountId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => (this.arSettlementUnitOptional && params.data.receivable ? {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              methodParams: { active: true },
              filterable: true,
              callbackParams: { key: 'accountId' },
              callbackMethodType: 'value',
              staticOptions: this.companyFactorySigns
            }
          } : {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              methodParams: { active: true },
              filterable: true,
              callbackParams: { key: 'accountId' },
              callbackMethodType: 'value',
              staticOptions: this.customerStaticOptions
            }
          }),
          onCellValueChanged: params => this.onCellChange(params),
          width: 200
        },
        {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          colId: 'invoiceTitle',
          field: 'invoiceTitle',
          initialWidth: 180,
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => (this.arSettlementUnitOptional && params.data.receivable ? {
            selectProps: {
              tagValue: 'invoiceTitle',
              tagName: 'invoiceTitle',
              allowCreate: !this.arSettlementUnitOptional,
              staticOptions: this.getInvoiceTitleList(params.data.accountId),
              filterable: true,
              filterTagNames: ['invoiceTitle'],
              filterType: 'global'
            }
          } : {
            selectProps: {
              tagValue: 'invoiceTitle',
              tagName: 'invoiceTitle',
              allowCreate: true,
              staticOptions: this.getInvoiceTitleList(params.data.accountId),
              filterable: true,
              filterTagNames: ['invoiceTitle'],
              filterType: 'global'
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPriceIncludeTax'),
          colId: 'unitPriceIncludeTax',
          field: 'unitPriceIncludeTax',
          width: 180,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return stringToBool(params.value) ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: this.inputIncludingTaxUnitPrice > 0,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t('SeaExport.Oversea'),
          colId: 'oversea',
          field: 'oversea',
          cellRenderer: (params) => {
            return ColumnUtils.overseaLabelFunc(params.value)
          },
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: [{ code: false, value: this.$t('CargoMsg.Cargo_Domestic') }, { code: true, value: this.$t('CargoMsg.Cargo_International') }],
            tagName: 'value',
            tagValue: 'code'
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_DrawABillOrNot'),
          colId: 'needInvoice',
          field: 'needInvoice',
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: [{ code: true, value: this.$t('CargoMsg.Cargo_Yes') }, { code: false, value: this.$t('CargoMsg.Cargo_No') }],
            tagName: 'value',
            tagValue: 'code'
          }
        },
        {
          headerName: this.$t('Payment.controlledOrNot'),
          colId: 'controlled',
          field: 'controlled',
          editable: (params) => {
            return params.data.receivable ? this.isCostControlled : this.isControlled
          },
          hide: this.isControlledShow,
          suppressColumnsToolPanel: this.isControlledShow,
          cellEditor: 'CargoAgGridSelectEditor',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: [{ code: true, value: this.$t('CargoMsg.Cargo_Yes') }, { code: false, value: this.$t('CargoMsg.Cargo_No') }],
            tagName: 'value',
            tagValue: 'code'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          colId: 'currency',
          field: 'currency',
          suppressMenu: true,
          width: 150,
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Currency,
              filterable: true,
              callbackParams: { key: 'currency' }
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t('CargoMsg.Cargo_Unit'),
          colId: 'measure',
          field: 'measure',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              clearable: false,
              filterable: true,
              fields: ['chineseName'],
              callbackParams: { key: 'measure' },
              callbackMethodType: 'value',
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
            }
          },
          onCellValueChanged: params => this.onCellChange(params),
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContainerSize'),
          colId: 'eqSize',
          field: 'eqSize',
          valueFormatter: params => {
            return ColumnUtils.eqSizeLabelFun(params.value)
          },
          editable: params => params.data.measure === BY_CNTR_CHARGE_MEASURE.code,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: EQ_SIZES,
            tagName: 'name',
            tagValue: 'code'
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContainerType'),
          colId: 'eqType',
          field: 'eqType',
          editable: params => params.data.measure === BY_CNTR_CHARGE_MEASURE.code,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: this.eqTypes,
            tagName: 'code',
            tagValue: 'code'
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_AmountNumber'),
          colId: 'quantity',
          field: 'quantity',
          cellRenderer: (params) => {
            return ColumnUtils.returnTwoZeroFormatNumber(params.value)
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2,
              max: 999999999,
              min: 0
            }
          },
          onCellValueChanged: params => this.onCellChange(params),
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_UnitPrice'),
          colId: 'unitRate',
          field: 'unitRate',
          cellRenderer: (params) => {
            return ColumnUtils.returnTwoZeroFormatNumber(params.value)
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2,
              max: 999999999,
              min: -999999999
            }
          },
          onCellValueChanged: params => this.onCellChange(params),
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_TaxRatePct'),
          colId: 'taxRate',
          field: 'taxRate',
          cellRenderer: (params) => {
            return ColumnUtils.returnTwoZeroFormatNumber(params.value)
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2,
              max: 999999999,
              min: -999999999
            }
          },
          onCellValueChanged: params => this.onCellChange(params),
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_TaxAmount'),
          colId: 'taxAmount',
          field: 'taxAmount',
          cellRenderer: (params) => {
            return ColumnUtils.returnTwoZeroFormatNumber(params.value)
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          colId: 'remarks',
          field: 'remarks',
          width: 100,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {}
        }
      ]
      if (parseInt(cache.config.get('CanUpdateExchangeRate')) === 1) {
        result.push({
          headerName: this.$t('CargoMsg.Cargo_ExchangeRate2'),
          colId: 'exchangeRate',
          field: 'exchangeRate',
          cellRenderer: (params) => {
            return ColumnUtils.roundHalfUp(params.value, 8)
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              max: 999999999,
              min: -999999999
            }
          },
          width: 150,
          onCellValueChanged: params => this.onCellChange(params)
        })
      }
      return result
    },
    isControlledShow() {
      return !(this.isControlled || this.isCostControlled)
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      } else {
        // 当弹框显示时，如果有选择的费用方案，应用到费用项中
        this.applySelectedScheme()
      }
      this.$emit('update:visible', newVal)
    },
    selectedScheme: {
      handler(newScheme) {
        if (newScheme && this.innerVisible) {
          // 当费用方案变化且弹框显示时，重新应用费用方案
          this.applySelectedScheme()
        }
      },
      deep: true,
      immediate: false
    }
  },
  async created() {
    if (this.visible) {
      this.innerVisible = true
    }
    await this.prepareData()
    this.loadSalesPrivateCustomer()
    if (this.lob === 'SE' || this.lob === 'SI') {
      this.partnerTypeList.push({ desc: this.$t('Message.TerminalCompany'), code: 'terminalCompany' })
    }
  },
  methods: {
    async prepareData() {
      await cache.load(cacheName.OFFICE, cacheName.DEPARTMENT, cacheName.USER, cacheName.CONFIG)
      this.office = cache.office
      this.department = cache.department
      this.user = cache.user
      this.chargeWeightValueType = ChargeUtils.getChargeWeightValueType(true)
      this.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
      this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
      this.currencyChangeBySettlementAccount = parseInt(cache.config.get('currencyChangeBySettlementAccount'))
      this.inputIncludingTaxUnitPrice = parseInt(cache.config.get('InputIncludingTaxUnitPrice'))
      this.companyFactorySigns = []
      if (this.arSettlementUnitOptional && this.selectedJobs && this.selectedJobs.length > 0) {
        this.companyFactorySigns = await ChargeUtils.getCompanyFactorySign(this.selectedJobs[0].customerId)
      }
      this.initChargeItemSet()
    },
    initChargeItemSet() {
      const results = chargeItemCompatibleLanguage()
      this.chargeItemSet = new Set(results)
    },
    // 应用选择的费用方案到费用项中
    async applySelectedScheme() {
      if (this.selectedScheme) {
        // 将费用方案中的费用项添加到表格中
        const compKeys = []
        const titleMap = new Map()
        for (const item of this.selectedScheme) {
          if (item.accountId > 0) {
            if (!compKeys.includes(item.accountId)) {
              compKeys.push(item.accountId)
            }
          }
        }
        if (compKeys.length > 0) {
          const titleMaps = await queryTitlesByCmpIdx(compKeys).then(res => res.data)
          compKeys.forEach(id => {
            if (!titleMap.has(id) && titleMaps[id]) {
              const titles = titleMaps[id]
              // 使用 find 查找默认抬头，找不到则取第一个
              const selectedTitle = titles.find(item => item.defaultTitle) || titles[0]
              titleMap.set(id, selectedTitle)
            }
          })
        }
        for (const item of this.selectedScheme) {
          const localCurrency = RateUtil.localCurrencyByOfficeId(this.office.officeId)
          let exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, item.currency, null, this.office.officeId, function(rate) {
            exchangeRate = rate
          })
          let partnerType = item.partnerType
          if (partnerType === 'customer') {
            partnerType = 'customerId'
          } else if (partnerType === 'carrier') {
            partnerType = 'carrierId'
          }
          const titleObject = titleMap.get(item.accountId)
          const title = titleObject?.title || await Company.getCompanyName(item.accountId)
          const row = new Charge({
            chargeItemId: item.chargeItemId,
            receivable: item.receivable || false,
            partnerType: partnerType,
            accountId: item.accountId || '',
            invoiceTitle: title || '',
            unitPriceIncludeTax: item.unitPriceIncludeTax || false,
            oversea: item.oversea || false,
            needInvoice: item.needInvoice || false,
            controlled: item.controlled || false,
            currency: item.currency || 'USD',
            measure: item.measure || '',
            eqSize: item.eqSize || '',
            eqType: item.eqType || '',
            unitRate: item.unitRate || 0,
            taxRate: item.taxRate || 0,
            quantity: item.quantity || 1, // 添加quantity字段，默认为1
            exchangeRate: exchangeRate,
            remarks: item.remark || ''
          })
          this.rowData.push(row)
        }
      }
    },
    // 外部销售只能加载自己的客户
    loadSalesPrivateCustomer() {
      if (Number(cache.config.get('AccountObjectControlMode')) === 1 && !this.$store.getters.isAdmin && (this.$checkPermission(['role_SalesQueryModule_salesCustomer']) || this.$checkPermission(['role_SalesQueryModule_departmentCustomer']))) {
        getCustomerByRole({ branch: this.$store.getters.currentOfficeId }).then(res => {
          this.customerCmpList = getFilterCacheList(TYPE_NAMES.basic_data_Company, p => res.data.includes(p.cmpIdx))
        })
      }
    },
    // 计算合计显示
    calculateTotalDisplay(isReceivable) {
      if (!this.rowData || this.rowData.length === 0) {
        return '0.00'
      }

      // 过滤出对应类型的费用（应收或应付）
      const filteredRows = this.rowData.filter(row => row.receivable === isReceivable)

      if (filteredRows.length === 0) {
        return '0.00'
      }

      // 按币种分组并计算总额
      const currencyMap = {}
      filteredRows.forEach(row => {
        const currency = row.currency || 'USD'
        const unitRate = row.unitRate || 0
        const quantity = row.quantity || 1
        const totalAmount = unitRate * quantity

        if (!currencyMap[currency]) {
          currencyMap[currency] = 0
        }
        currencyMap[currency] += totalAmount
      })

      // 构建显示文本：RMB:600.00 USD:400.00
      const displayParts = []
      for (const [currency, amount] of Object.entries(currencyMap)) {
        displayParts.push(`${currency}:${amount.toFixed(2)}`)
      }

      return displayParts.length > 0 ? displayParts.join(' ') : '0.00'
    },
    getChargeItemFilter() {
      let filter = {}
      switch (this.lob) {
        case 'SE':
          filter = !this.isControlledShow ? { seaExport: true, active: true } : { seaExport: true, controlled: false, active: true }
          break
        case 'SI':
          filter = !this.isControlledShow ? { seaImport: true, active: true } : { seaImport: true, controlled: false, active: true }
          break
        case 'AE':
          filter = !this.isControlledShow ? { airExport: true, active: true } : { airExport: true, controlled: false, active: true }
          break
        case 'AI':
          filter = !this.isControlledShow ? { airImport: true, active: true } : { airImport: true, controlled: false, active: true }
          break
        case 'RE':
        case 'RI':
          filter = !this.isControlledShow ? { railwayExport: true, active: true } : { railwayExport: true, controlled: false, active: true }
          break
        case 'FBA_SE':
          filter = { fbaSea: true, active: true }
          break
        case 'FBA_AE':
          filter = { fbaAir: true, active: true }
          break
        case 'FBA_RE':
          filter = { fbaRailway: true, active: true }
          break
        case 'IE':
          filter = !this.isControlledShow ? { integratedJob: true, active: true } : { integratedJob: true, controlled: false, active: true }
          break
        default:
      }
      if (this.isSpecialExpenseEntryFunction) {
        filter.specialExpenseMarker = false
      }
      return filter
    },
    async onCellChange(params) {
      const { node, data } = params
      let firstAccountId = false
      if (!params.oldValue) {
        firstAccountId = true
      }
      data.firstAccountId = firstAccountId
      const filed = params.colDef.field
      if (filed === 'exchangeRate') {
        const exchangeRate = CurrencyUtil.truncateRateByCurrency(data.currency, data.exchangeRate)
        if (exchangeRate !== data.exchangeRate) {
          node.setDataValue('exchangeRate', exchangeRate)
          return
        }
      }
      switch (filed) {
        case 'receivable':
          this.customerStaticOptions = data.receivable ? this.customerCmpList : null
          data.controlled = false
          node.setDataValue('controlled', data.controlled)
          break
        case 'chargeItemId':
          this.refreshChargeItemId(node, data)
          break
        case 'accountId':
          await this.refreshAccountId(node, data)
          break
        case 'invoiceTitle':
          node.setDataValue('invoiceTitle', data.invoiceTitle)
          break
        case 'currency':
          this.refreshCurrency(node, data)
          break
        case 'measure':
          if (data.measure !== BY_CNTR_CHARGE_MEASURE.code) {
            data.eqSize = ''
            data.eqType = ''
            node.setDataValue('eqSize', data.eqSize)
            node.setDataValue('eqType', data.eqType)
          }
          break
        case 'unitRate':
          this.refreshUnitRate(node, data)
          // 强制触发Vue响应式更新，使computed属性重新计算
          this.$forceUpdate()
          break
        case 'taxRate':
          this.refreshTaxRate(node, data)
          break
        case 'unitPriceIncludeTax':
          this.refreshUnitPriceIncludeTax(node, data)
          break
        case 'quantity':
          // 数量变化时强制触发Vue响应式更新，使computed属性重新计算
          this.$forceUpdate()
          break
      }
    },
    // 费用名称
    refreshChargeItemId(node, data) {
      if (!data.chargeItemId) {
        return
      }
      const chargeItem = getObjectByCache(basicCacheKeys.basic_data_ChargeItem, 'itemId', data.chargeItemId)
      const localCurrency = RateUtil.localCurrencyByOfficeId(data.branchId)
      data.currency = chargeItem.defaultapcurrency || localCurrency
      if (!chargeItem.defaultapcurrency && data.accountId) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(data.accountId))
        data.currency = (company && (company.designationAgent || company.overseaAgent)) ? 'USD' : localCurrency
      }
      data.measure = chargeItem.measure
      data.quantity = 1
      data.unitRate = !chargeItem.defaultarprice ? 0 : chargeItem.defaultarprice
      data.taxRate = chargeItem ? (chargeItem.taxRate || 0) : 0
      // CARGO-31003 在新增费用时，直接对特定的费用进行受控
      data.controlled = chargeItem?.controlled
      data.needInvoice = chargeItem?.needInvoice
      node.setDataValue('currency', data.currency)
      node.setDataValue('measure', data.measure)
      node.setDataValue('unitRate', data.unitRate)
      node.setDataValue('taxRate', data.taxRate)
      node.setDataValue('controlled', data.controlled)
      node.setDataValue('needInvoice', data.needInvoice)
    },
    // 结算对象
    async refreshAccountId(node, data) {
      if (!data.accountId) {
        return
      }
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', data.accountId)
      if (company) {
        data.oversea = (company.designationAgent || company.overseaAgent)
      }
      // CARGO-52436 更改结算对象时，不应该联动修改币种
      if (this.currencyChangeBySettlementAccount === 2 || (this.currencyChangeBySettlementAccount === 1 && data.firstAccountId)) {
        const localCurrency = RateUtil.localCurrencyByOfficeId(data.branchId)
        data.currency = localCurrency
        if (company) {
          if (company.designationAgent || company.overseaAgent) {
            data.currency = 'USD'
          }
        }
      }
      // CARGO-31015 录入或修改费用名称，不论费用名称在收费项目维护的税率是否为0，都以费用名称的税率更新此条费用的税率，0税率的税率也为0（以费用名称税率为准）
      // ChargeUtils.changeItemRate(data, this.office)
      ChargeUtils.changeChargeRateByAccountId(data)
      if (!data.taxRate) data.taxRate = 0.00

      // 开票抬头默认：应付→结算对象(公司名)；应收→维护抬头的默认逻辑
      if (!data.receivable) {
        data.invoiceTitle = company ? company.chineseName : data.invoiceTitle
      } else {
        // 加载开票抬头
        await this.getTitlesByCompanyId(data.accountId)
        const invoiceTitleList = this.getInvoiceTitleList(data.accountId)
        if (invoiceTitleList && invoiceTitleList.length > 0) {
          const invoiceTitle = invoiceTitleList.find(p => p.title === data.invoiceTitle)
          if (invoiceTitle && invoiceTitle.suitWhtTax) {
            const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', data.chargeItemId)
            if (chargeItem && chargeItem.defaultWhtRate > 0) {
              data.whtTaxRate = chargeItem.defaultWhtRate
            }
          } else {
            data.invoiceTitle = invoiceTitleList[0].title
          }
        } else {
          data.invoiceTitle = company.chineseName
        }
      }
      node.setDataValue('currency', data.currency)
      node.setDataValue('oversea', data.oversea)
      node.setDataValue('taxRate', data.taxRate)
      node.setDataValue('invoiceTitle', data.invoiceTitle)
      node.setDataValue('whtTaxRate', data.whtTaxRate)
    },
    // 币种
    async refreshCurrency(node, data) {
      if (!data.currency) return
      const localCurrency = RateUtil.localCurrencyByOfficeId(data.branchId)
      data.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, data.currency, null, data.branchId, function(rate) {
        data.exchangeRate = rate
      })
      node.setDataValue('exchangeRate', data.exchangeRate)
    },
    // 单价
    refreshUnitRate(node, data) {
      const unitRate = Number(data.unitRate)
      if (!isNaN(unitRate)) {
        // ChargeUtils.calculateTax(data, unitRate * data.quantity, Number(data.taxRate))
        if (data.unitPriceIncludeTax) {
          ChargeUtils.calculateTaxAmount(data, multiply(unitRate, data.quantity), data.taxRate)
        } else {
          ChargeUtils.calculateTax(data, multiply(unitRate, data.quantity), data.taxRate)
        }
        node.setDataValue('taxAmount', data.taxAmount)
        node.setDataValue('amount', data.amount)
        node.setDataValue('excludingTaxAmount', data.excludingTaxAmount)
        node.setDataValue('unitRate', data.unitRate)
      }
    },
    // 税率
    refreshTaxRate(node, data) {
      const taxRate = Number(data.taxRate)
      if (!isNaN(taxRate)) {
        // ChargeUtils.calculateTax(data, data.excludingTaxAmount, taxRate, true)
        if (data.unitPriceIncludeTax) {
          ChargeUtils.calculateTaxAmount(data, Number(data.amount), taxRate)
        } else {
          ChargeUtils.calculateTax(data, Number(data.excludingTaxAmount), taxRate)
        }
        node.setDataValue('taxAmount', data.taxAmount)
        node.setDataValue('unitRate', data.unitRate)
      }
    },
    refreshUnitPriceIncludeTax(node, data) {
      if (data.unitPriceIncludeTax) {
        ChargeUtils.calculateTaxAmount(data, data.unitRate * data.quantity, data.taxRate)
      } else {
        ChargeUtils.calculateTax(data, data.unitRate * data.quantity, data.taxRate)
      }
      node.setDataValue('taxAmount', data.taxAmount)
      node.setDataValue('unitRate', data.unitRate)
    },
    async toAdd() {
      const row = new Charge().fillDefaultValue().getData()
      row.branchId = this.office.officeId
      row.oversea = false
      row.receivable = this.chargeType !== 2
      row.unitPriceIncludeTax = this.inputIncludingTaxUnitPrice === 2
      row.currency = 'USD'
      const localCurrency = RateUtil.localCurrencyByOffice()
      row.localCurrency = localCurrency
      row.exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, row.currency, new Date(), 0, 0, false)
      row.eqSize = ''
      row.eqType = ''
      this.rowData.push(row)
    },
    toChangeSchema() {
      this.$emit('toChangeSchema')
    },
    toRemove() {
      if (this.rowData.length === 0) {
        this.$message.warning(this.$t('Message.NoFeesCanBeDeleted'))
        return
      }
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedCharge'))
        return
      }
      for (const row of rows) {
        const index = this.rowData.indexOf(row)
        this.rowData.splice(index, 1)
      }
    },
    async toSave() {
      if (this.rowData.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoFeesCanBeAdded'))
        return
      }
      if (this.selectedJobs && this.selectedJobs.length > 0) {
        const jobKeys = Array.from(this.selectedJobs, p => p.uuid)
        // const pass = await validateChargeLockStatusByType(jobKeys, { type: this.chargeType }).then(res => res.data)
        if (this.chargeType === 0) {
          this.loading = getLoading()
          const pass = await validateChargeLockStatus(jobKeys).then(res => res.data).finally(() => {
            this.loading.close()
          })
          if (!pass) {
            this.$message.error(this.$t('CargoMsg.Cargo_ChargeLockStatusChanged'))
            return
          }
        }
      }
      const cmpIds = []
      for (const charge of this.rowData) {
        charge.exchangeRate = Number(charge.exchangeRate)
        charge.unitRate = Number(charge.unitRate)
        charge.taxRate = Number(charge.taxRate)
        if (isNaN(charge.taxAmount) || !charge.taxAmount) {
          charge.taxAmount = 0.00
        }
        if (isNaN(charge.taxRate) || !charge.taxRate) {
          charge.taxRate = 0.00
        }
        if (charge.chargeItemId <= 0) {
          this.$message.warning(this.$t('Message.ChargeNameCannotBeEmpty'))
          return
        }
        if (charge.accountId <= 0 && !charge.partnerType) {
          this.$message.warning(this.$t('Message.ClearingTheObjectCannotBeNull'))
          return
        }
        if (charge.measure === BY_CNTR_CHARGE_MEASURE.code && (!charge.eqSize && !charge.eqType)) {
          this.$message.error(this.$t('CargoMsg.Cargo_PleaseEnterBoxTypeOrBoxType'))
          return
        }
        if (charge.chargeItemId) {
          const message = ChargeUtils.checkChargeRateRange(charge)
          if (message) {
            this.$message.warning(this.$t('CargoMsg.Cargo_TaxRateRangeLimit', [message]))
            return
          }
        }
      }
      if (!await ChargeUtils.checkUnitRate(this.rowData, this, false)) {
        return
      }
      const jobKeys = []
      const newCharges = []
      this.loading = getLoading()
      try {
        for (const job of this.selectedJobs) {
          const seaEqs = await seaEQList({ jobUuid: job.uuid }).then(res => res.data)
          if (seaEqs && seaEqs.length > 0) {
            job.seaEQ = seaEqs
          }
          if (job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === job.typeHBL) {
            const seaCargoDocs = await jobApi.getCargoDoc({ jobUuid: job.uuid }).then(async res => res.data)
            if (seaCargoDocs && seaCargoDocs.length > 0) {
              job.seaCargoDoc = seaCargoDocs
            }
          }
          for (const charge of this.rowData) {
            if (charge.quantity > 0) {
              const newCharge = ChargeUtils.copyCharge(charge, this.user, this.department, this.office)
              // 当汇率为空或者设置了 不允许手动修改汇率 时汇率按照业务日期取汇率
              if (isNaN(charge.exchangeRate) || charge.exchangeRate <= 0 || parseInt(cache.config.get('CanUpdateExchangeRate')) === 0) {
                if (!job.businessDate) {
                  this.$message.warning(this.$t('SeaExport.ExchangeRateCannotBe0'))
                  return
                }
                const localCurrency = RateUtil.localCurrencyByOfficeId(newCharge.branchId)
                const exchangeRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, newCharge.currency, job.businessDate, newCharge.branchId, 0, false)
                if (!isNaN(exchangeRate) && exchangeRate > 0) {
                  newCharge.exchangeRate = exchangeRate
                } else {
                  Assert.isTrue(false, lang.t('baseInfo.rateManagement.notFoundRate', [newCharge.currency]))
                  return
                }
              }
              newCharge.needInvoice = charge.needInvoice
              // 如果用户已手动设置数量，则保留用户输入的值；否则使用系统计算的默认值
              if (charge.quantity && charge.quantity > 0 && !charge.quantityCalculated) {
                newCharge.quantity = charge.quantity
              } else {
                await ChargeColumnUtil.refreshQuantity(newCharge, job)
              }
              if (newCharge.quantity === 0) {
                this.$message.warning('[' + job.jobNo + ']' + this.$t('Message.BusinessNumberIs0'))
                return
              }
              if (Number(newCharge.accountId) === 0 && newCharge.partnerType) {
                const accountId = job[newCharge.partnerType] || 0
                newCharge.accountId = accountId
                if (accountId === 0) {
                  this.getPartnerTypeErrorMsg(job, newCharge.partnerType)
                  return false
                }
                const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(newCharge.accountId))
                if (company) {
                  newCharge.oversea = (company.designationAgent || company.overseaAgent)
                }
              }
              cmpIds.push(newCharge.accountId)
              if (newCharge.taxRate === 0 || String(newCharge.taxRate) === 'NaN') {
                ChargeUtils.changeItemRate(newCharge, this.office)
              }
              newCharge.businessDate = job.businessDate

              // CARGO-55573 海创：批量新增费用添加开票抬头
              newCharge.invoiceTitle = charge.invoiceTitle
              // // 发票抬头放在后端处理了
              // if (!newCharge.invoiceTitle) {
              //   newCharge.invoiceTitle = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(newCharge.accountId), 'chineseName')
              // }
              newCharge.jobUuid = job.uuid
              if (charge.measure === BY_CNTR_CHARGE_MEASURE.code) {
                for (const seaEq of seaEqs) {
                  let flag = false
                  if (charge.eqSize) {
                    if (charge.eqSize === seaEq.eqSize) {
                      flag = charge.eqType && this.eqTypeMap(charge.eqType) === this.eqTypeMap(seaEq.eqType) || !charge.eqType
                    }
                  } else {
                    flag = charge.eqType && this.eqTypeMap(charge.eqType) === this.eqTypeMap(seaEq.eqType)
                  }
                  if (flag) {
                    const copyCharge = { ...newCharge, measure: this.eqToChargeMeasure(seaEq), quantity: seaEq.eqQuantity }
                    // ChargeUtils.calculateTax(copyCharge, copyCharge.quantity * copyCharge.unitRate, copyCharge.taxRate)
                    if (copyCharge.unitPriceIncludeTax) {
                      ChargeUtils.calculateTaxAmount(copyCharge, copyCharge.unitRate * copyCharge.quantity, copyCharge.taxRate)
                    } else {
                      ChargeUtils.calculateTax(copyCharge, copyCharge.quantity * copyCharge.unitRate, copyCharge.taxRate)
                    }
                    newCharges.push(copyCharge)
                  }
                }
              } else {
                // ChargeUtils.calculateTax(newCharge, newCharge.quantity * newCharge.unitRate, newCharge.taxRate)
                if (newCharge.unitPriceIncludeTax) {
                  ChargeUtils.calculateTaxAmount(newCharge, newCharge.unitRate * newCharge.quantity, newCharge.taxRate)
                } else {
                  ChargeUtils.calculateTax(newCharge, newCharge.quantity * newCharge.unitRate, newCharge.taxRate)
                }
                newCharges.push(newCharge)
              }
            }
          }
          jobKeys.push(job.uuid)
        }
        if (newCharges.length === 0) {
          this.$alert(this.$t('Message.NotMatchingTheCostOfTheProjectCanBeAdded'), this.$t('common.tips.prompt'), {
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t('common.btn.ok')
          })
          return
        }
        await batchSaveCharge({ charges: newCharges, cmpIds: cmpIds, jobKeys: jobKeys, location: this.location }).then(res => {
          if (res.data > 0) {
            this.$message.success(this.$t('Message.AddSuccessfully'))
            this.innerVisible = false
          } else {
            this.$message.error(this.$t('CargoMsg.Cargo_OperationFailed'))
          }
        })
      } finally {
        this.loading.close()
      }
    },
    /**
     * eqType映射（HQ和HC视为同一种箱种）
     */
    eqTypeMap(eqType) {
      if (eqType === 'HQ') {
        return 'HQ_HC'
      } else if (eqType === 'HC') {
        return 'HQ_HC'
      } else {
        return eqType
      }
    },
    eqToChargeMeasure(seqEq) {
      let measure = ''
      switch (seqEq.eqSize) {
        case '20':
          measure = 'C20'
          break
        case '40':
          if (seqEq.eqType === 'HC') {
            measure = 'C40H'
          } else {
            measure = 'C40'
          }
          break
        case '45':
          measure = 'C45'
          break
      }
      return measure
    },
    getPartnerTypeErrorMsg(job, partnerType) {
      switch (partnerType) {
        case 'customerId':
        {
          this.$message.warning(this.$t('[' + job.jobNo + ']' + this.$t('Message.CustomerIsNULL') + this.$t('Message.TheObjectCannotBeUsedAsTheDefaultSettlement')))
          break
        }
        case 'customer':
        {
          this.$message.warning(this.$t('[' + job.jobNo + ']' + this.$t('Message.CustomerIsNULL') + this.$t('Message.TheObjectCannotBeUsedAsTheDefaultSettlement')))
          break
        }
        case 'carrierId':
        {
          this.$message.warning('[' + job.jobNo + ']' + this.$t('Message.TheCarrierIsEmpty') + this.$t('Message.TheObjectCannotBeUsedAsTheDefaultSettlement'))
          break
        }
        case 'carrier':
        {
          this.$message.warning('[' + job.jobNo + ']' + this.$t('Message.TheCarrierIsEmpty') + this.$t('Message.TheObjectCannotBeUsedAsTheDefaultSettlement'))
          break
        }
        case 'bookingAgent':
        {
          this.$message.warning('[' + job.jobNo + ']' + this.$t('Message.AgentIsNULL') + this.$t('Message.TheObjectCannotBeUsedAsTheDefaultSettlement'))
          break
        }
        case 'terminalCompany':
        {
          this.$message.warning('[' + job.jobNo + ']' + this.$t('Message.TerminalCompanyIsNull') + this.$t('Message.TheObjectCannotBeUsedAsTheDefaultSettlement'))
          break
        }
        case 'destinationAgent':
        {
          this.$message.warning('[' + job.jobNo + ']' + this.$t('Message.AgentIsNULL2') + this.$t('Message.TheObjectCannotBeUsedAsTheDefaultSettlement'))
          break
        }
        case 'customsBroker':
        {
          this.$message.warning('[' + job.jobNo + ']' + this.$t('Message.CustomsIsNull') + this.$t('Message.TheObjectCannotBeUsedAsTheDefaultSettlement'))
          break
        }
        default:
        {
          break
        }
      }
    },
    toCancel() {
      this.innerVisible = false
    },
    async getTitlesByCompanyId(accountId) {
      if (!accountId || accountId <= 0) return
      if (this.customerTitlesMap.has(accountId)) {
        return this.customerTitlesMap.get(accountId)
      }
      // 获取数据库中维护的开票抬头
      const res = await queryTitleByCpmIdx(accountId)
      const dbTitles = res.data || []
      if (dbTitles.length > 0) {
        for (const title of dbTitles) {
          if (!title.title) continue
          title.invoiceTitle = title.title
        }
      }
      this.customerTitlesMap.set(accountId, dbTitles)
      return this.customerTitlesMap.get(accountId)
    },
    getInvoiceTitleList(accountId) {
      if (this.customerTitlesMap.get(accountId)) {
        return this.customerTitlesMap.get(accountId).reduce((res, item) => {
          if (!res.find(re => re.invoiceTitle === item.invoiceTitle && re.taxAccount === item.taxAccount)) {
            res.push(item)
          }
          return res
        }, [])
      }
      return []
    }
  }
}
</script>

<style scoped lang="scss">
  #app .app-main-inner ::v-deep .el-dialog__body {
    padding: 10px;
  }
</style>
